import debug from 'debug';

const loggerBaseString: string = import.meta.env.LOGGER_BASE_STRING || 'dashboard-react';

const generateMessage = (level: string, message: any, ...args: any[]) => {
  // Set the prefix which will cause debug to enable the message
  const namespace = `${loggerBaseString}:${level}`;
  const createDebug = debug(namespace);

  createDebug(message, ...args);
};

const trace = (message: any, ...args: any[]) => {
  return generateMessage('trace', message, ...args);
};

const info = (message: any, ...args: any[]) => {
  return generateMessage('info', message, ...args);
};

const error = (message: any, ...args: any[]) => {
  return generateMessage('error', message, ...args);
};

const Logger = {
  trace,
  info,
  error,
};

export default Logger;
